<app-modal>
  <app-loading *ngIf="loading"></app-loading>
  <ng-container *ngIf="!loading">
    <app-modal-header [title]="headerText" (closed)="confirmClose()"></app-modal-header>

    <app-modal-body>
      <div class="overflow-hidden" [formGroup]="eventForm">
        <section class="row col-row-space custom-gutters section-padding">
          <div class="col-12">
            <app-text-field
              [formGroup]="eventForm"
              formControlName="title"
              name="title"
              [placeholder]="(T.defaultLocalizations.title.one | translate) + '*'"
              [maxLength]="80"
              [displayError]="triggerErrors"
              [minLength]="3"
              [disabled]="eventId && event.externalIntegrationType !== integrationTypes.None"
              [autofocus]="true"
              [required]="true"
              [useReactiveMessages]="true">
            </app-text-field>
          </div>

          <div class="col-12">
            <app-optional-date-time
              [firstDateString]="event.startDate"
              [secondDateString]="event.endDate"
              [showPickers]="true"
              [editMode]="true"
              [disabled]="eventId && event.externalIntegrationType !== integrationTypes.None"
              [showCheckbox]="false"
              (onFirstDateChanged)="onStartTimeChanged($event)"
              (onSecondDateChanged)="onEndTimeChanged($event)"
            ></app-optional-date-time>
          </div>

          <div class="col-12">
            <app-filter-dropdown-new
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Event_Type"
              [appliedFilters]="event.filters"
              [disableMargin]="true"
              [typeahead]="true"
              [disabled]="eventId &&event.externalIntegrationType !== integrationTypes.None"
              [label]="T.common.choose_item | translate: { item: localisedEventType }"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
          </div>

          <div class="col-12">
            <app-filter-dropdown-new
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Zone"
              [appliedFilters]="event.filters"
              [disableMargin]="true"
              [typeahead]="true"
              [label]="'Zone'"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
          </div>

          <div class="col-12">
            <app-filter-dropdown-new
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Area"
              [appliedFilters]="event.filters"
              [disableMargin]="true"
              [typeahead]="true"
              [label]="'Area'"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
          </div>
        </section>
      </div>
    </app-modal-body>

    <app-modal-footer>
      <app-button-rectangle
        [buttonTheme]="'white'"
        [size]="'large'"
        [text]="T.common.cancel | translate"
        (clicked)="confirmClose()"
      ></app-button-rectangle>
      <app-button-rectangle
        [size]="'large'"
        [text]="T.common.save | translate"
        (clicked)="onConfirm()"
        [disabled]="!modalIsValid()"
      ></app-button-rectangle>
    </app-modal-footer>
  </ng-container>
</app-modal>
